module.exports = __webpack_public_path__ + "static/AzoSans-Medium-17abff431db767ddbccdf2e517b92862.ttf";